export default __webpack_public_path__ + "static/media/11.db1f26f5.jpg";